import { Link } from "@tanstack/react-router";
import { navigation, site, brand } from "@/content";
import { Aurora, Grain, Particles, spotlightPointer } from "@/components/motion";
import { Logo } from "@/components/logo";

export function SiteFooter() {
  const year = new Date().getFullYear();
  return (
    <footer onMouseMove={spotlightPointer} className="spotlight horizon-field pb-16 text-white lg:pb-0">
      <Aurora />
        <Grain />
      <Particles count={8} />
      <div className="relative z-10 mx-auto max-w-6xl px-6 py-16">
        <div className="grid gap-12 md:grid-cols-4">
          <div className="md:col-span-1">
            <Logo onDark />
            <p className="mt-4 text-sm text-ivory/70">{brand.positioning}</p>
          </div>
          <FooterColumn title="Services" items={navigation.services} />
          <FooterColumn title="Industries" items={navigation.industries} />
          <div>
            <p className="text-sm font-medium text-mint">Company</p>
            <ul className="mt-4 space-y-2">
              {navigation.main.map((item) => (
                <li key={item.href}>
                  <Link to={item.href} className="link-underline text-sm text-white/85 hover:text-white">
                    {item.label}
                  </Link>
                </li>
              ))}
              <li>
                <Link to="/contact" className="link-underline text-sm text-white/85 hover:text-white">
                  Contact
                </Link>
              </li>
              <li>
                <Link
                  to="/frequently-asked-questions"
                  className="link-underline text-sm text-white/85 hover:text-white"
                >
                  FAQ
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-4 border-t border-white/10 pt-6 md:flex-row md:items-center md:justify-between">
          <p className="text-xs text-white/60">
            © {year} {site.brandName}. All rights reserved.
            <br className="hidden md:inline" /> {site.legalWording}
          </p>
          <div className="flex gap-6 text-xs text-white/70">
            <Link to="/privacy" className="hover:text-white">
              Privacy
            </Link>
            <Link to="/terms" className="hover:text-white">
              Terms
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}

function FooterColumn({
  title,
  items,
}: {
  title: string;
  items: { label: string; href: string }[];
}) {
  return (
    <div>
      <p className="text-sm font-medium text-mint">{title}</p>
      <ul className="mt-4 space-y-2">
        {items.map((item) => (
          <li key={item.href}>
            <Link to={item.href} className="link-underline text-sm text-white/85 hover:text-white">
              {item.label}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
